import { render, staticRenderFns } from "./ResItem.vue?vue&type=template&id=789efca9&scoped=true&"
import script from "./ResItem.vue?vue&type=script&lang=js&"
export * from "./ResItem.vue?vue&type=script&lang=js&"
import style0 from "./ResItem.vue?vue&type=style&index=0&id=789efca9&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789efca9",
  null
  
)

export default component.exports